import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './cache/store'
import './registerServiceWorker'

import VueSweetalert2 from 'vue-sweetalert2';
import Vuetify from 'vuetify'
import SnackbarMixin from './mixins/snackbar'
import('../node_modules/vuetify/dist/vuetify.min.css')

Vue.config.productionTip = false

Vue.use(VueSweetalert2)
Vue.use(Vuetify)

Vue.use(Vuetify, {
  theme: {
    primary: '#DCB546',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.mixin(SnackbarMixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
